import { observer }       from 'mobx-react';
import { IntlProvider }   from 'react-intl';
import { appStore }       from 'stores/AppStore';
import { FR }             from 'constants/Languages';
import type { ReactNode } from 'react';

interface Props {
	children: ReactNode;
}

export const IntlProviderWrapper = observer(({ children }: Props) => {
  return (
    <IntlProvider
      key={appStore.locale} // Le key force le refresh des composants traduits
      locale={appStore.locale}
      messages={appStore.messages}
      defaultLocale={FR.value}
    >
      {children}
    </IntlProvider>
  );
});